import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useCurrentContract from 'products/nomad_insurance/hooks/useCurrentContract';
import BaseModal from '../BaseModal';
import ActionButtons from './components/ActionButtons';
import ContractItem from './components/ContractItem';
import { Text } from './styled';

const ClaimProviderModal = ({ isOpen, onClose }) => {
  const { contractsIncludingExpired } = useCurrentContract();
  const sortedContracts = [...contractsIncludingExpired]?.reverse();
  const [selectedContract, setSelectedContract] = useState(sortedContracts[0] || null);

  const handleClose = () => {
    onClose();
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={handleClose}
      heading="Which policy is your claim related to?"
    >
      <Text>
        Select the policy that covers the date of incident you are claiming for.
      </Text>
      {sortedContracts?.map((contract) => (
        <ContractItem
          key={contract.policyID}
          selectedContract={selectedContract}
          setSelectedContract={setSelectedContract}
          contract={contract}
        />
      ))}

      <ActionButtons selectedContract={selectedContract} onClose={onClose} />
    </BaseModal>
  );
};

ClaimProviderModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default ClaimProviderModal;
